<nirby-icon-picker [icon]="icon" (iconChange)="selectIcon($event)">
</nirby-icon-picker>
